import { useContext } from "react";
import { CommonMapContext } from "../contexts/CommonMapContext";

const useCommonMap = () => useContext(CommonMapContext);

export default useCommonMap;
